import { type SVGProps } from 'react';

export const IconGooglePlay = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M3.61 1.814L13.793 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .61-.92zm.637-.292L14.842 8.37l-2.59 2.586L4.247 1.522zm10.72 8.974l2.185-2.183 3.862 2.196c.667.38.667 1.002 0 1.381l-3.862 2.197-2.185-2.184zM4.247 22.478l8.005-9.434 2.59 2.586-10.595 6.848z" />
  </svg>
);
